<template>
  <div class="row">
    <div class="col d-flex align-items-center">
      <div class="d-flex align-items-center">
        <h6 class="mb-0">
          <a href="javascript:void(0)" @click="showSubRetailer(false)">
            <i class="fa-solid fa-arrow-left me-2" v-if="isAdmin"></i>
            {{ selectedRetailer.name }}
          </a>
        </h6>
      
      </div>
      <div class="ms-5">
        <label class="mb-0 text-xs">
          Balance:
            <strong v-if="selectedRetailer.balance">
              &#8369;
              {{ selectedRetailer.balance.toLocaleString("en") }}
            </strong>
        </label>
        <label class="mb-0 text-xs ms-5">
          Earmarked:
            <strong v-if="selectedRetailer.earmarked">
              &#8369;
              {{ selectedRetailer.earmarked.toLocaleString("en") }}
            </strong>
         
        </label>

        <label class="mb-0 text-xs ms-5 d-none">
          Total Rebate To Transfer
            <strong v-if="selectedRetailer.earmarked">
              &#8369;
              {{ selectedRetailer.earmarked.toLocaleString("en") }}
            </strong>
        </label>
      </div>
    </div>
    <!-- <div class="col-6 d-flex align-items-end">
      <button class="btn bg-gradient-dark mb-0 ms-auto" @click="showLoadSubscriberSidebar">
        <i class="fas fa-sim-card me-1"></i>
        Buy Load
      </button>
    </div> -->
    <load-subscriber-sidebar />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import loadSubscriberSidebar from "./sidebar/loadSubscriber.vue";

export default {
  components: {
    loadSubscriberSidebar,
  },
  computed: {
    ...mapState({
      retailers: (state) => state.retailerController.retailers,
      selectedRetailer: (state) => state.retailerController.selectedRetailer,
    }),
    ...mapGetters({
      user: 'adminController/admin',
    }),
    isAdmin() {
        return this.user.role === 'admin';
    },
  },
  methods: {
    ...mapMutations({
      showSubRetailer: "retailerController/SET_ShowSubRetailer",
      showLoadSubscriberSidebar:
        "retailerController/TOGGLE_ShowLoadSubscriberSidebar",
      setSelectedRetailer: "retailerController/SET_SelectedRetailer",
    }),
    ...mapActions({
      getRetailers: "retailerController/GetRetailers",
      getSubRetailers: "retailerController/GetSubRetailers",
      getProducts: "productController/GetProducts",
      getCategories: "productController/GetCategories",
    }),
  },
  async mounted() {
    await this.getRetailers();
    const fetchedRetailers = this.$store.state.retailerController.retailers;
    if (fetchedRetailers.length > 0 && !this.isAdmin) { this.setSelectedRetailer(fetchedRetailers[0]); }
    await this.getSubRetailers(); //tech debt - duplicate calling when master dealer, low prio (very minor perframance cost)
  },
};
</script>

<style></style>